import CommonButton from "components/atoms/buttons/CommonButton/CommonButton";
import { RefObject } from "react";
import { Input } from "styles/mixinStyles";
import { AddInputContainer } from "./AddInput.style";

interface AddInputProps {
  inputRef: RefObject<HTMLInputElement>;
  handleClick: () => void;
  buttonLabel: string;
}

const AddInput = ({inputRef, handleClick, buttonLabel}: AddInputProps) => {
  return (
    <AddInputContainer>
      <Input type="text" ref={inputRef} />
      <CommonButton label={buttonLabel} handleClick={handleClick}/>
    </AddInputContainer>
  );
};

export default AddInput;